import { render } from "./ZNBJadd.vue?vue&type=template&id=4b374905&scoped=true"
import script from "./ZNBJadd.vue?vue&type=script&lang=js"
export * from "./ZNBJadd.vue?vue&type=script&lang=js"

import "./ZNBJadd.vue?vue&type=style&index=0&id=4b374905&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b374905"]])

export default __exports__